export default function Unit({ number, data, tall }) {
  return (
    <div className={`unit ${tall ? "tall" : ""} ${data?.isRented ? "rented" : ""}`}>
      
      <button
        className="unit-button"
        disabled
      >
        <span className="unit-number">{number}</span>
      </button>

      {data?.isRented && (
        <div className="renter-name">
          {data.renterName || ""}
        </div>
      )}

      {data && <div className="unit-name">{data.name}</div>}
    </div>
  );
}